import { useAppDispatch } from './redux';
import { addNotification, removeNotification } from '@/store/slices/uiSlice';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface NotificationOptions {
  duration?: number;
}

export const useNotification = () => {
  const dispatch = useAppDispatch();

  const showNotification = (
    type: NotificationType,
    title: string,
    message: string,
    options: NotificationOptions = {}
  ) => {
    const id = Date.now().toString();
    
    dispatch(addNotification({
      type,
      title,
      message,
      duration: options.duration || 5000,
    }));

    // Auto-remove notification after duration
    if (options.duration !== 0) {
      setTimeout(() => {
        dispatch(removeNotification(id));
      }, options.duration || 5000);
    }

    return id;
  };

  const showSuccess = (title: string, message: string, options?: NotificationOptions) => {
    return showNotification('success', title, message, options);
  };

  const showError = (title: string, message: string, options?: NotificationOptions) => {
    return showNotification('error', title, message, options);
  };

  const showWarning = (title: string, message: string, options?: NotificationOptions) => {
    return showNotification('warning', title, message, options);
  };

  const showInfo = (title: string, message: string, options?: NotificationOptions) => {
    return showNotification('info', title, message, options);
  };

  const hideNotification = (id: string) => {
    dispatch(removeNotification(id));
  };

  return {
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    hideNotification,
  };
};